export default __webpack_public_path__ + "static/media/cartIcon.61338b52.svg";